import { render, staticRenderFns } from "./robotTable.vue?vue&type=template&id=0b17a800&scoped=true&"
import script from "./robotTable.vue?vue&type=script&lang=js&"
export * from "./robotTable.vue?vue&type=script&lang=js&"
import style0 from "./robotTable.vue?vue&type=style&index=0&id=0b17a800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b17a800",
  null
  
)

export default component.exports